import { NgModule } from '@angular/core';

import { SbbIcon } from './icon';

@NgModule({
  declarations: [SbbIcon],
  exports: [SbbIcon],
})
export class SbbIconModule {}
